import { useTranslation } from 'react-i18next';

import { ICompanySettings } from 'auth/types';
import { Total, TotalPrice } from 'core/elements';
import { NumberHelper } from 'core/helpers';
import { PricingHelper } from 'pricing/helpers';
import { FreightStatus } from 'quotes/enums';
import { IQuoteVersionData } from 'quotes/types';
import { Color, Level } from 'theme/enums';

import { getTotalFreight } from './utils';

interface IProps {
  quoteVersionData: IQuoteVersionData;
  label?: string;
  freightSettings?: Pick<ICompanySettings, 'defaultFreightPercentage' | 'minimumFreightCharge'>;
  classNames?: string;
  valueProps?: { color?: Color; level?: Level; onClick?: () => void };
}

const FreightStatusValueLabel = {
  [FreightStatus.SPREAD]: 'labelFreightSpread',
  [FreightStatus.PREPAID_AND_CHARGE]: 'labelFreightPrepaidAndCharge',
};

export const FreightValue = ({
  quoteVersionData,
  label,
  freightSettings = {},
  classNames = '',
  valueProps = {},
}: IProps) => {
  const { t } = useTranslation();

  const valueLabel = FreightStatusValueLabel[quoteVersionData?.freightStatus];

  const priceWarning =
    NumberHelper.compare(quoteVersionData?.freightPrice, freightSettings.minimumFreightCharge) < 0
      ? t('errorFreightTotalBellowMinimum', {
          minimum: PricingHelper.formatPricing({ amount: freightSettings.minimumFreightCharge }),
        })
      : '';

  if (valueLabel) {
    return (
      <Total
        label={label || t('labelFreight')}
        value={t(valueLabel).toUpperCase()}
        options={{ classNames, valueProps }}
      />
    );
  }

  return (
    <TotalPrice
      label={label || t('labelFreight')}
      value={getTotalFreight(quoteVersionData)}
      options={{ classNames, warning: priceWarning, valueProps }}
    />
  );
};
